import React, { useState, useEffect } from "react";
import { toast } from "react-toastify";
import { useApi } from "../../../../hooks/useApi";
import Loader from "../../../DefaultStyles/Loader";
import { Textarea } from "../../../Input/Textarea";
import AlertModal from "../../../Modal/AlertModal";
import DefaultModalLayout from "../../../Modal/DefaultModalLayout";
import { DeleteModalLabel } from "../../Users/UserDetail/CommentModal/CommentDeleteModal";
import { DefaultModalCommonProps } from "../../Users/UserDetail/CommentModal/CommentModal";

interface PartyInviteRegChangeModalProps extends DefaultModalCommonProps {
  data: {
    partyId: string;
    uid: number;
    cur_needreg: number;
  };
}

export default function PartyInviteRegChangeModal({
  closeEvent,
  confirmEvent,
  data,
}: PartyInviteRegChangeModalProps) {
  const [reason, setReason] = useState("");
  const [regUpdateAskModal, setRegUpdateAskModal] = useState(false);
  const [regUpdateBtnClick, setRegUpdateBtnClick] = useState(false);
  const [newNeedreg, setNewNeedreg] = useState<number>(data?.cur_needreg ?? 0);

  // 등록 완료로 업데이트
  const { response, error, loading } = useApi({
    method: "post",
    url: regUpdateBtnClick ? `party/reg` : undefined,
    data: {
      partyid: +data?.partyId?.split("_")[0] ?? 0,
      uid: data?.uid ?? 0,
      needreg: newNeedreg,
      reason,
    },
  });

  useEffect(() => {
    if (error) {
      if (error.code === 400) {
        toast.error("등록 완료 처리에 실패했습니다.");
      }
    }
  }, [error]);

  useEffect(() => {
    if (response?.status === 200) {
      closeEvent();
      if (confirmEvent) {
        confirmEvent();
      }

      toast.success("등록 완료 처리를 성공했습니다.");
    }
  }, [response]);


  return (
    <DefaultModalLayout
      modalTitle="등록 상태 변경하기"
      isMediumModal={true}
      closeEvent={() => closeEvent()}
      confirmEvent={() => setRegUpdateAskModal(true)}
      type="input"
      confirmDisabled={reason === ""}
    >
      <DeleteModalLabel>등록 상태 변경 사유</DeleteModalLabel>
      <DeleteModalLabel>현재 등록 상태 : {data?.cur_needreg === 0? "등록완료" : data?.cur_needreg === 1 ? "최초등록전" : data?.cur_needreg === 2 ? "수정 등록 전" : ""}</DeleteModalLabel>
      <DeleteModalLabel>변경 등록 상태</DeleteModalLabel> 
      <div style={{ display: "flex", gap: "16px", marginBottom: "12px" }}>
        {/* <label>
          <input
            type="radio"
            name="needreg"
            value={-1}
            checked={newNeedreg === -1}
            onChange={(e) => setNewNeedreg(Number(e.target.value))}
          />
          초대함 (-1)
        </label> */}
        <label>
          <input
            type="radio"
            name="needreg"
            value={0}
            checked={newNeedreg === 0}
            onChange={(e) => setNewNeedreg(Number(e.target.value))}
          />
          등록완료 (0)
        </label>
        <label>
          <input
            type="radio"
            name="needreg"
            value={1}
            checked={newNeedreg === 1}
            onChange={(e) => setNewNeedreg(Number(e.target.value))}
          />
          최초등록전 (1)
        </label>
        <label>
          <input
            type="radio"
            name="needreg"
            value={2}
            checked={newNeedreg === 2}
            onChange={(e) => setNewNeedreg(Number(e.target.value))}
          />
          수정 등록 전 (2)
        </label>
      </div>

      <Textarea
        placeholder="등록 상태 변경 사유 입력(100글자 이내)"
        onChange={(e) => setReason(e.target.value)}
        value={reason}
      />

      <>
        {loading && <Loader />}

        {regUpdateAskModal && (
          <AlertModal
            title={`${data?.uid}님을
        ${data?.partyId} 파티에
        등록 상태 변경 처리 하시겠습니까?`}
            confirmEvent={() => {
              setRegUpdateAskModal(false);
              setRegUpdateBtnClick(true);
            }}
            cancelEvent={() => setRegUpdateAskModal(false)}
            btnColor={"mint"}
          />
        )}
      </>
    </DefaultModalLayout>
  );
}
